import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CopyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M7.5 4.125H5.25C4.65326 4.125 4.08097 4.36205 3.65901 4.78401C3.23705 5.20597 3 5.77826 3 6.375V19.875C3 20.4717 3.23705 21.044 3.65901 21.466C4.08097 21.8879 4.65326 22.125 5.25 22.125H16.5C17.0967 22.125 17.669 21.8879 18.091 21.466C18.5129 21.044 18.75 20.4717 18.75 19.875V18.75M7.5 4.125C7.5 4.72174 7.73705 5.29403 8.15901 5.71599C8.58097 6.13795 9.15326 6.375 9.75 6.375H12C12.5967 6.375 13.169 6.13795 13.591 5.71599C14.0129 5.29403 14.25 4.72174 14.25 4.125M7.5 4.125C7.5 3.52826 7.73705 2.95597 8.15901 2.53401C8.58097 2.11205 9.15326 1.875 9.75 1.875H12C12.5967 1.875 13.169 2.11205 13.591 2.53401C14.0129 2.95597 14.25 3.52826 14.25 4.125M14.25 4.125H16.5C17.0967 4.125 17.669 4.36205 18.091 4.78401C18.5129 5.20597 18.75 5.77826 18.75 6.375V9.75M21 14.25H9.75M9.75 14.25L13.125 10.875M9.75 14.25L13.125 17.625"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

CopyIcon.displayName = 'CopyIcon';
